import {
	ButtonGroup,
	Heading,
	Icon,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import { IconTrash } from '@tabler/icons';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import React from 'react';
import { useDeleteFamily } from 'services/queryClient/wrapperHooks/useDeleteFamily';
import { useDeleteProductModel } from 'services/queryClient/wrapperHooks/useDeleteProductModel';
import { useDeleteSubFamily } from 'services/queryClient/wrapperHooks/useDeleteSubFamily';

import { familyMessages } from './variables/familyMessages';

interface IModalDeleteProps {
	type: 'family' | 'subFamily' | 'productModel';
	isOpen: boolean;
	onClose: () => void;
	removeId: number | string;
}

const ModalDelete = (props: IModalDeleteProps) => {
	const { type, isOpen, onClose, removeId } = props;

	const { mutate: deleteFamily } = useDeleteFamily();
	const { mutate: deleteSubFamily } = useDeleteSubFamily();
	const { mutate: deleteProductModel } = useDeleteProductModel();

	function getModalTitle() {
		const modalTitleMap = {
			family: familyMessages.MODAL_TITLES.DELETE_FAMILY,
			subFamily: familyMessages.MODAL_TITLES.DELETE_SUBFAMILY,
			productModel: familyMessages.MODAL_TITLES.DELETE_MODEL,
		};

		return modalTitleMap[type] ?? '';
	}

	function getDeleteMessage() {
		const deleteMessageMap = {
			family: familyMessages.DESCRIPTION.FAMILY_DELETE_DETAILED,
			subFamily: familyMessages.DESCRIPTION.SUBFAMILY_DELETE_DETAILED,
			productModel: familyMessages.DESCRIPTION.MODEL_DELETE_DETAILED,
		};

		return deleteMessageMap[type] ?? '';
	}

	function handleDelete() {
		switch (type) {
			case 'family':
				deleteFamily(removeId);
				break;
			case 'subFamily':
				deleteSubFamily(removeId);
				break;
			case 'productModel':
				deleteProductModel(removeId);
				break;
		}

		onClose();
	}

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			isCentered
		>
			<ModalOverlay />
			<ModalContent
				borderRadius={20}
				pt='20px'
			>
				<ModalCloseButton />
				<ModalBody>
					<Icon
						as={IconTrash}
						color='easyRED.300'
						w={8}
						h={8}
						mb={4}
					/>
					<Heading
						color='gray.700'
						mb={2}
						size='md'
					>
						{getModalTitle()}
					</Heading>
					<Text
						color='gray.500'
						fontSize='sm'
						mb={3}
					>
						{getDeleteMessage()}
					</Text>
					<Text
						color='easyRED.300'
						fontSize='sm'
						fontWeight='bold'
					>
						{familyMessages.DESCRIPTION.DELETE_IRREVERSIBLE}
					</Text>
				</ModalBody>

				<ModalFooter>
					<ButtonGroup>
						<ButtonComponent
							data-test='button-cancelar-modal-familia'
							type='ghost'
							title={familyMessages.LABELS.CANCEL}
							onClick={onClose}
						/>
						<ButtonComponent
							data-test='button-excluir-modal-familia'
							type='secondary'
							title={familyMessages.LABELS.DELETE}
							onClick={handleDelete}
						/>
					</ButtonGroup>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default ModalDelete;
